// extracted by mini-css-extract-plugin
export default {"text":"RegisterCarMethod_text__P+-pg","image":"RegisterCarMethod_image__cMzg3","btnImage":"RegisterCarMethod_btnImage__ED8Nv","carousel":"RegisterCarMethod_carousel__Vt-d0"};